import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';

import Loading from 'uI/Loading/Loading';

import UserCourseCard from './userCourseCard/UserCourseCard';

import { incompleteCourses } from 'store/campus-actions';

import classes from './MyCourses.module.css';

const MyCourses = () => {
  const [courses, setCourses] = useState([]);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    (async () => {
      setCourses(await incompleteCourses());
      setLoad(false);
    })();
  }, []);

  return (
    <>
      {!load ? (
        <>
          <div className={classes.titleContainer}>
            <p className={classes.title}>Mis Cursos en proceso</p>
            <span className={classes.extraInfo}>
              Para consultar tus <strong>cursos terminados</strong>{' '}
              ve a la sección de{' '}
              <Button
                component={Link}
                to="/myPortfolio"
                className={classes.portfolioBtn}
              >
                "Mis Diplomas"
              </Button>
            </span>
          </div>
          <div className={classes.coursesContainer}>
            <ul className={classes.listCourses}>
              {courses.map(course => (
                <li
                  key={course.idCourse}
                  className={classes.courseContainer}
                >
                  <UserCourseCard course={course} />
                </li>
              ))}
            </ul>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default MyCourses;
